module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-100italic.d1f3f2d02ee4d7d2d4b1ad865014f189.woff";